module.exports = __webpack_public_path__ + "static/social-f52bb6c9df79fb064525c8a2c72effc6.jpg";